import { Component } from '@angular/core';
import {UserService} from '../../../../user.service';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { Router} from '@angular/router';

@Component({
  selector: 'app-awsop-lab3',
  templateUrl: './awsop-lab3.component.html',
  styleUrls: ['./awsop-lab3.component.css']
})
export class AwsopLab3Component  {

  labState = {};
  ec2_instance_id = '';
  ec2_dns = '';

  constructor(public ngxSmartModalService: NgxSmartModalService, private userService: UserService, private router: Router) { }


  verifyLab3() {
    if (this.ec2_instance_id.length == 0 || this.ec2_dns.length == 0 ) {
      alert("Missing EC2 Info")
    }

    this.userService.verifyLab3(this.ec2_instance_id, this.ec2_dns).subscribe(
      res => {
        let pass = res['checks']["overallPass"]
        this.labState['lab3'] = pass;
        if (pass) {
          alert('You passed!!')
        } else {
          alert("You failed lab 3. Please try again.")
        }
      },
      err => {
        console.log("Error occured", err);
      }
    );

  }

  openPopup() {
    this.ngxSmartModalService.getModal('infoModal').open()
  }
}



// WEBPACK FOOTER //
// ./src/app/course/labs/awsop/awsop-lab3/awsop-lab3.component.ts